import { pilot } from '~/services/serviceInstances';

interface Request {
  externalId: string;
}

interface Response {}

export const getExternalDocumentForDebug = async ({
  externalId,
}: Request): Promise<Response> => {
  const response = await pilot.get(`/document/debug`, {
    params: { external_id: externalId },
  });
  return response;
};
